<template>
  <div class="container">
    <div class="searchBox" :style="{ opacity: config.isConfigMode ? 0.5 : 1, pointerEvents: config.isConfigMode ? 'none' : 'auto' }">
      <el-form :inline="true" :model="dataForm.paramMap" size="small">
        <el-form-item label="标题">
          <el-input v-model="dataForm.paramMap.title" placeholder="请输入标题" clearable></el-input>
        </el-form-item>
        <el-form-item label="短语">
          <el-input v-model="dataForm.paramMap.phrase" placeholder="请输入短语" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select class="item-choose" v-model="dataForm.paramMap.messageType" filterable clearable placeholder="类型">
            <el-option v-for="item in dictTypeMap.message_type" :key="item.id" :label="item.name" :value="item.code.toString()"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优先级">
          <el-select class="item-choose" v-model="dataForm.paramMap.priority" filterable clearable placeholder="优先级">
            <el-option label="普通" :value="'0'"></el-option>
            <el-option label="重要" :value="'1'"></el-option>
            <el-option label="紧急" :value="'2'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="终端类型">
          <el-select class="item-choose" v-model="dataForm.paramMap.terminalType" filterable clearable placeholder="终端类型">
            <el-option label="全平台" :value="'0'"></el-option>
            <el-option label="司机端" :value="'1'"></el-option>
            <el-option label="调度端/PC端" :value="'2'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可见范围">
          <el-select class="item-choose" v-model="dataForm.paramMap.globalType" filterable clearable placeholder="可见范围">
            <el-option label="全员可见" :value="'0'"></el-option>
            <el-option label="指定人员" :value="'1'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息方式">
          <el-select class="item-choose" v-model="dataForm.paramMap.confirm" filterable clearable placeholder="是否需确认">
            <el-option label="自动确认" :value="'0'"></el-option>
            <el-option label="手动确认" :value="'1'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getList()" type="primary">查询</el-button>
          <el-button @click="editOrAdd({}, 'info')" type="success">添加消息</el-button>
          <el-button size="small" @click="templateConfigurationMode(0)" type="warning">模板配置模式</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox tenants-list" :style="{ position: 'relative' }">


      <!-- 配置模式 -->
      <el-row v-if="config.isConfigMode" style="justify-self: center;padding: 10px 10px">
        <el-button size="mini" @click="config.isConfigMode = false" type="danger">取消配置模式</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(1)" type="success">保存模板</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(2)" type="warning">修改模板</el-button>
        <el-button v-no-more-click size="mini" @click="$refs.configTableRef.init(config.configTableId)" type="warning">所有模板</el-button>
        <el-popover placement="right" width="520" trigger="click">
          <div style="justify-self: center;">
            <el-button v-no-more-click @click="checkAllNodes(true)" size="mini">全选</el-button>
            <el-button v-no-more-click @click="checkAllNodes(false)" size="mini">全不选</el-button>
            <el-tooltip class="item" effect="dark" content="可拖拽必须先取消固定才允许拖拽排列,如果有固定固定按钮会显示为绿色" placement="top-start">
              <i class="el-icon-view el-icon--right" />
            </el-tooltip>
          </div>
          <br/>
          <el-tree :data="config.configDefaultColumn"
                   style="max-height: 200px;overflow-y: auto;"
                   default-expand-all
                   show-checkbox
                   draggable
                   node-key="prop"
                   ref="configTableListTree"
                   @check-change="handleCheckChange"
                   @node-drop="handleDrop"
                   :allow-drag="allowDrag"
                   :allow-drop="allowDrop">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <el-row :gutter="20">
                       <el-col :span="16">
                         <div class="grid-content bg-purple">
                           <el-input size="mini" placeholder="列头名" v-model="data.label"></el-input>
                         </div>
                       </el-col>
                       <el-col :span="8">
                         <div class="grid-content bg-purple">
                           <el-link :type="data.fixed && data.fixed === 'left' ? 'success' : 'info'" @click="data.fixed = 'left'" :underline="false" >固定左侧</el-link>
                           <el-link :type="data.fixed && data.fixed === 'right' ? 'success' : 'info'" @click="data.fixed = 'right'" :underline="false" >固定右侧</el-link>
                           <el-link :disabled="!data.fixed" :underline="false" @click="data.fixed = undefined" >取消固定</el-link>
                         </div>
                       </el-col>
                    </el-row>
                  </span>
          </el-tree>
          <el-button style="margin-left: 10px;" size="mini" slot="reference" icon="el-icon-s-tools" circle />
        </el-popover>
        <br/>
        <br/>
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-input v-model="config.configModeForm.name" size="mini" placeholder="模板名称" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple-light">
              <el-input v-model="config.configModeForm.remark" size="mini" placeholder="备注" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-switch
                  v-model="config.configModeForm.defaultOrNot"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="'1'"
                  :inactive-value="'0'">
              </el-switch>
            </div>
          </el-col>
        </el-row>
      </el-row>
      <el-table :data="tablelist"
                ref="tableRef"
                @row-dblclick="rowClick"
                height="72vh"
                size="small"
                v-loading="tableLoading"
                border
                style="width: 100%;"
                :cell-class-name="getCellClassName">
        <el-table-column
            v-for="(item, index) in config.configDefaultColumn"
            :key="index"
            align="left"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :show-overflow-tooltip="true"
            v-if="item.check"
            :class="item.styleClass"
            :class-name="item.styleClass">
          <template slot-scope="scope">
            <!-- 类型 -->
            <template v-if="item.prop == 'messageType'">
              <el-tag> {{ messageTypeMap.get(scope.row.messageType) }} </el-tag>
            </template>
            <!-- 优先级 -->
            <template v-else-if="item.prop == 'priority'">
              <el-tag v-if="scope.row.priority == 0">普通</el-tag>
              <el-tag v-if="scope.row.priority == 1" type="warning">重要</el-tag>
              <el-tag v-if="scope.row.priority == 2" type="danger">紧急</el-tag>
            </template>
            <!-- 终端类型 -->
            <template v-else-if="item.prop == 'terminalType'">
              <el-tag v-if="scope.row.terminalType == 0">全平台</el-tag>
              <el-tag v-if="scope.row.terminalType == 1">司机端</el-tag>
              <el-tag v-if="scope.row.terminalType == 2">调度端/PC端</el-tag>
            </template>
            <!-- 可见范围 -->
            <template v-else-if="item.prop == 'globalType'">
              <el-tag v-if="scope.row.globalType == 0">全员可见</el-tag>
              <el-tag v-if="scope.row.globalType == 1">指定人员</el-tag>
            </template>
            <!-- 消息方式 -->
            <template v-else-if="item.prop == 'confirm'">
              <el-tag v-if="scope.row.confirm == 0">自动确认</el-tag>
              <el-tag v-if="scope.row.confirm == 1">手动确认</el-tag>
            </template>
            <template v-else>
              {{ getFormatter(item.formatter)(scope.row, item, _.get(scope.row, item.prop)) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="320">
          <template slot-scope="scope">
            <el-button @click="viewBulletin(scope.row)" type="text" size="mini">查看</el-button>
            <el-button @click="editOrAdd(scope.row)" type="text" size="mini">编辑</el-button>
            <el-button @click="deleteV(scope.row)" type="text" size="mini">删除</el-button>
            <el-button @click="checkTheSentPersonnel(scope.row)" type="text" size="mini">查看记录</el-button>
            <el-button @click="sendMessage(scope.row)" type="text" :disabled="scope.row.globalType == 0 || scope.row.terminalType == 0" size="mini">添加指定接收人</el-button>
            <el-button @click="goBiz(scope.row)" type="text" size="mini" v-if="scope.row.targetId">前往</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="dataForm.page"
                     :page-sizes="[20, 50, 100]" :page-size="dataForm.size" :total="dataForm.total"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>


    <el-drawer :title="dialo.title" :visible.sync="drawer" direction="rtl" :append-to-body="true">
      <tipTap ref="tipTapRef" v-model="dialo.content" :editable="false" v-if="drawer" />
    </el-drawer>

    <!-- 模板配置弹窗 -->
    <configTable ref="configTableRef" />

    <announPopup ref="announPopup" @cancel="getList" />

    <!-- 选择人员发送 -->
    <el-dialog title="选择人员" :visible.sync="selectPersonnel.dialogVisible" v-if="selectPersonnel.dialogVisible" :close-on-click-modal="false" width="80%" :append-to-body="true">
      <driver ref="sendMessageRef" v-if="selectPersonnel.driverVisible" />
      <user ref="sendMessageRef" v-if="selectPersonnel.userVisible" />
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="sendMessageSubmit">确 认</el-button>
      <el-button type="primary" @click="selectPersonnel.dialogVisible = false">返 回</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import announPopup from './components/announ-popup.vue'
import tipTap from '@/components/el-tiptap'
import configTable from '@/components/table'
import * as myJsonClon from "@/utils/myJsonClone"
import driver from "@/views/modules/transport/driver.vue"
import user from "@/views/modules/sys/user.vue"
import * as myPageColumConfig from "@/utils/pageColumConfig";
import { isMenuAuth } from '@/utils'
export default {
  components: {configTable,tipTap,driver,user,announPopup},
  data() {
    return {
      // -----------------动态表格模式start-----------------
      config: myPageColumConfig.message,
      // -----------------动态表格模式end-----------------


      dataForm: {
        page: 1,
        size: 20,
        total: 0,
        paramMap: {}
      },
      totalPage: 0,
      tableLoading: false,
      tablelist: [],
      drawer: false,
      dialo: {},

      // 选择人员
      selectPersonnel: {
        dialogVisible: false,
        driverVisible: false,
        userVisible: false,
        list: [],
        row: undefined,
      },
    }
  },
  computed: {
    mainTabs: {
      get () {
        return this.$store.state.common.mainTabs
      },
      set (val) {
        this.$store.commit('common/updateMainTabs', val)
      }
    },
    dictTypeMap: {
      get() {
        return this.$store.state.common.dictTypeMap
      }
    },
    messageTypeMap() {
      let messageTypeDict = this.dictTypeMap.message_type;
      if (messageTypeDict && messageTypeDict.length > 0) {
        return new Map(messageTypeDict.map(item => [item.code, item.name]));
      }
      return new Map();
    }
  },
  created() {
    this.initConfigTable()
    this.getList()
  },
  methods: {
    // -----------------动态表格模式start-----------------
    initConfigTable() {
      this.$http({
        url: this.$http.adornUrl('/tabulation/default/' + this.config.configTableId),
        method: 'get',
        params: this.$http.adornParams()
      }).then(async ({ data }) => {
        if (data) {
          this.config.configModeForm.name = data.name
          this.config.configModeForm.remark = data.remark
          this.config.configModeForm.defaultOrNot = data.defaultOrNot
          this.config.configId = data.id
          if (data.tmsTabulationConfigValueList && data.tmsTabulationConfigValueList.length > 0) {
            this.assignPropertiesLarge(this.config.configDefaultColumn, data.tmsTabulationConfigValueList,'prop',['label','fixed','width'])
            this.config.configDefaultColumn = this.reorderArray(this.config.configDefaultColumn, data.tmsTabulationConfigValueList, 'prop');
          }
        }
        this.config.configDefaultColumn.forEach(x => {
          this.config.configDefaultPropColumn.push({prop: x.prop})
          this.config.configDefaultPropColumnMap.set(x.prop,x)
        })
      })

    },
    assignPropertiesLarge (arr1, arr2, compareProp, assignProps) {
      const map = new Map();
      arr2.forEach(item => {
        map.set(item[compareProp], item);
      });
      arr1.forEach(item => {
        const match = map.get(item[compareProp]);
        if (match) {
          assignProps.forEach(prop => {
            item[prop] = match[prop];
          });
          item.check = true
        } else {
          item.check = false
        }
      });
      return arr1;
    },
    reorderArray(arr1, arr2, key) {
      if (arr2.length === 0) {
        return arr1;
      }

      // 存储第二个数组中元素的特定属性值
      const targetValues = arr2.map(item => item[key]);
      // 存储匹配的元素
      const matched = [];
      // 存储未匹配的元素
      const unmatched = [];

      // 遍历第一个数组，将匹配的元素和未匹配的元素分别存储
      for (const item of arr1) {
        if (targetValues.includes(item[key])) {
          matched.push(item);
        } else {
          unmatched.push(item);
        }
      }

      // 对匹配的元素进行排序，使其顺序与第二个数组一致
      const sortedMatched = targetValues.map(value => {
        return matched.find(item => item[key] == value);
      }).filter(item => item!== undefined);
      // 合并匹配的元素和未匹配的元素
      return [...sortedMatched, ...unmatched];
    },
    templateConfigurationMode(type) {
      // 开启配置模式
      if (type === 0) {
        this.config.isConfigMode = true
        this.$nextTick(() => {
          const tree = this.$refs.configTableListTree;
          this.config.configDefaultColumn.forEach((node) => {
            if (node.check) {
              tree.setChecked(node.prop, true);
            }
          });
        })
      }
      // 保存/修改配置模式
      else if (type === 1 || type === 2) {
        // 检测
        if (!this.config.configModeForm.name) {
          this.$message.error('请输入配置模板名称!');
          return
        }
        if (type === 2) {

          if (!this.config.configId) {
            this.$message.error('未检测出有配置相关模板并启用,请新增!');
            return
          }
        }
        this.$nextTick(() => {
          let submitTable = myJsonClon.getClone(this.config.configModeForm)
          submitTable.tableId = this.config.configTableId
          submitTable.id = type === 2 ? this.config.configId : undefined
          const tableRef = this.$refs.tableRef;
          let tmsTabulationConfigValueList = []
          tableRef.columns.forEach((x,index) => {
            tmsTabulationConfigValueList.push({label: x.label,prop: x.property,fixed: x.fixed,width: x.width,sort: index})
          })
          submitTable.tmsTabulationConfigValueList = tmsTabulationConfigValueList;
          this.$http({
            url: this.$http.adornUrl(type === 1 ? '/tabulation/add' : '/tabulation/update'),
            method: type === 1 ? 'post' : 'put',
            data: submitTable
          }).then(async ({ data }) => {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
            })
            window.location.reload()
          })

        })
      }
    },
    getFormatter(formatterName) {
      if (formatterName) {
        // 首先尝试从组件的 methods 中获取方法
        let method = this[formatterName];
        if (typeof method === 'function') {
          return method;
        }
        // 若组件的 methods 中没有，再尝试从 Vue.prototype 中获取方法
        method = Vue.prototype[formatterName];
        if (typeof method === 'function') {
          return method;
        }
      }
      // 若都没找到，返回一个直接返回原始值的函数
      return (row, column, cellValue) => cellValue;
    },
    checkAllNodes (isChecked) {
      this.$nextTick(() => {
        if (isChecked) {
          this.$refs.configTableListTree.setCheckedNodes(this.config.configDefaultPropColumn)
        } else {
          this.$refs.configTableListTree.setCheckedKeys([])
          this.$forceUpdate()
        }
      })
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      const tree = this.$refs.configTableListTree;
      tree.setChecked(draggingNode.data.prop, draggingNode.data.check);
    },
    handleCheckChange(data, checked, indeterminate) {
      const targetElement = this.config.configDefaultColumn.find(item => item.prop === data.prop);
      targetElement.check = checked
    },
    allowDrag(draggingNode) {
      return draggingNode.data.fixed ? false : true
    },
    allowDrop(draggingNode, dropNode, type) {
      return type === 'inner' ? false : true
    },
    getCellClassName({ row, column, rowIndex, columnIndex }) {
      let newVar = this.config.configDefaultPropColumnMap.get(column.property);
      if (newVar && newVar.styleClass) {
        return newVar.styleClass;
      }
      return '';
    },
    // -----------------动态表格模式end-----------------

    // 获取列表
    getList() {
      this.tableLoading = true
      this.$http({
        url: this.$http.adornUrl('/message_center/page'),
        method: 'post',
        data: this.dataForm
      }).then((data) => {
        this.tablelist = data.data.records
        this.dataForm.total = data.data.total
      }).finally(e => {
        this.tableLoading = false
      })
    },
    // 查看
    viewBulletin(row = {}) {
      this.dialo = row
      this.drawer = true
    },
    // 每页数
    sizeChangeHandle(val) {
      this.dataForm.size = val
      this.dataForm.page = 1
      this.getList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.dataForm.page = val
      this.getList()
    },
    // 点击行
    rowClick(row) {
      this.viewBulletin(row)
    },
    // 删除
    deleteV(row) {
      let THAT = this;
      this.$confirm('确定进行【删除】操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl(`/message_center/` + row.id ),
          method: 'delete',
        }).then(({ data }) => {
          if (data) {
            this.$message.success('删除成功')
            THAT.getList()
          }
        })
      }).catch(() => { })
    },
    // 修改/新增
    editOrAdd(row = {}) {
      this.$refs.announPopup.openDialog(row)
    },
    // 查看已发送人员
    checkTheSentPersonnel(row) {
      this.mainTabs = this.mainTabs.filter(item => item.name !== 'message-log')

      setTimeout(() => {
        this.$router.push({
          name: "message-log",
          params: { key: 'message-log',title: row.title, terminalType: row.terminalType,messageType: row.messageType,globalType: row.globalType,priority: row.priority},
        });
      },300)
    },



    // 发送信息
    sendMessage(row) {
      // 重置
      this.selectPersonnel = this.$options.data().selectPersonnel

      // 执行
      this.selectPersonnel.row = row
      this.selectPersonnel.dialogVisible = true
      if (row.terminalType == '1') {
        this.selectPersonnel.driverVisible = true
        setTimeout(() => {
          this.$refs.sendMessageRef.getDataList(1)
        }, 500)
      } else if (row.terminalType == '2') {
        this.selectPersonnel.userVisible = true
        setTimeout(() => {
          this.$refs.sendMessageRef.getDataList()
        }, 500)
      }

    },
    sendMessageSubmit() {
      this.selectPersonnel.list = this.$refs.sendMessageRef.getSelectionChangeHandle();
      if (this.selectPersonnel.list.length == 0) {
        this.$message.error('请选择人员')
        return
      }

      this.$http({
        url: this.$http.adornUrl('/message_center/recipient/' + this.selectPersonnel.row.id),
        method: 'POST',
        data: {ids: this.selectPersonnel.list.map(x => x.id)}
      }).then((data) => {
        this.$message.success('发送成功')
        this.selectPersonnel.dialogVisible = false
        this.selectPersonnel.userVisible = false
      }).finally(e => {})
    },

    // 前往业务
    goBiz(row) {
      let targetType = row.targetType;
      let targetId = row.targetId;
      if (!targetId || !targetType) {
        this.$message({
          message: '无法前往',
          type: 'warning',
          duration: 1000,
        })
        return
      }

      // 测试
      // 订单ID: d50da8c9b99e4d68ba3c3ce86904819f
      // 保险ID: ae50b2aad7ab4ff2af92b0827e2b28d1
      // 年审ID: cd10cae0f3014c9bab32ad3144ad2db1

      // 保险
      if (targetType == 'BASE_INSURE') {
        if (!this.checkAuth('certificates/InsuranceManagement')) {
          return;
        }
        this.goMenu(row,'certificates-InsuranceManagement')
        return;
      }

      // 年审
      if (targetType == 'VEHICLE_INSPECT') {
        if (!this.checkAuth('certificates/earlyWarning')) {
          return;
        }
        this.goMenu(row,'certificates-earlyWarning')
        return;
      }

      // 订单
      if (targetType == 'ORDER_INFO') {
        if (!this.checkAuth('order/list-inside')) {
          return;
        }
        this.goMenu(row,'order-list-inside')
        return;
      }
    },
    checkAuth(key) {
      if (!isMenuAuth(key)) {
        this.$message({
          message: '无权限前往',
          type: 'warning',
          duration: 1000,
        })
        return false;
      }
      return true
    },
    goMenu(row,key) {
      this.mainTabs = this.mainTabs.filter(item => item.name !== 'key')
      setTimeout(() => {
        this.$router.push({
          name: key,
          params: {
            goId: row.targetId,
          }
        })
      },300)
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-drawer__body {
  border-top: 1px solid #E4E7ED;
}

.drawer_wrap {
  padding: 10px;
  ::v-deep .el-date-editor{
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
